import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "as-standing__top" }
const _hoisted_2 = { class: "as-nav-tabs-btn" }
const _hoisted_3 = { class: "as-show-full as-scrolling as-scrolling__have-tab as-scrolling__result-popup" }
const _hoisted_4 = { class: "as-standing__table" }
const _hoisted_5 = { class: "as-standing__table-row as-standing__table-row-head" }

import { computed } from "vue";
import { usecommonStore } from "~src/stores/CommonStore";
import SkeletonLoader from "~src/components/SkeletonLoader.vue";
interface IProps {
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StandingListTabSkeleton',
  setup(__props: any) {

const commonStore = usecommonStore();

const props = __props;

const siteName = computed(() => commonStore.getSiteName);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`as-standing as-parent-standing as-parent-standing-${siteName.value}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(SkeletonLoader, {
          width: "80px",
          height: "30px",
          line: 1
        }),
        _createVNode(SkeletonLoader, {
          width: "80px",
          height: "30px",
          line: 1
        }),
        _createVNode(SkeletonLoader, {
          width: "80px",
          height: "30px",
          line: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (colIndex) => {
            return _createElementVNode("div", {
              key: colIndex,
              class: "as-standing__table-column",
              type: "button"
            }, [
              _createVNode(SkeletonLoader, {
                width: colIndex === 2 ? '120px' : colIndex > 2 ? '50px' : '30px',
                height: "20px",
                line: 1
              }, null, 8, ["width"])
            ])
          }), 64))
        ]),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(15, (rowIndex) => {
          return _createElementVNode("div", {
            key: rowIndex,
            class: "as-standing__table-row"
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (colIndex) => {
              return _createElementVNode("div", {
                key: colIndex,
                class: "as-standing__table-column"
              }, [
                _createVNode(SkeletonLoader, {
                  width: colIndex === 2 ? '120px' : colIndex > 2 ? '50px' : '30px',
                  height: "20px",
                  line: 1
                }, null, 8, ["width"])
              ])
            }), 64))
          ])
        }), 64))
      ])
    ])
  ], 2))
}
}

})